import Vue from "vue";
import Vuex from "vuex";
import { getIndexInfo } from "@/api/index";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    details: {
      image: "", //人生轨迹图片
      jianli: "", // 生平简介
      video_url: "" // 视频地址
    }
  },
  getters: {},
  mutations: {
    SET_DETAILS(state, data) {
      state.details = data;
    }
  },
  actions: {
    // getUserInfo({ commit }, data) {
    //   return getIndexInfo({ userId: data.id }).then(res => {
    //     if(res.auth_config){
    //       return commit("SET_DETAILS", res);
    //     }else{
    //       return false
    //     }
        
    //   }).catch();
    // }
  }
});
